import cookieUniversal from 'cookie-universal'

export default ({ req, res }, inject) => {
  const options = {
  "alias": "cookie",
  "parseJSON": false,
  "default": {
    "domain": ".staging.littlelives.com"
  }
}
  inject(options.alias, cookieUniversal(req, res, options.parseJSON))
}
